import React from 'react';
import './home.css';
import NaveBar from '../../components/footer/NaveBar/NaveBar'; 
import Footer from '../../components/footer/footer/footer';
import Product from '../../components/footer/product/Product';
import { useAuth } from '../../context/AuthContext'; 

function Home() {
  const { isLoggedIn } = useAuth();
  
  return (
    <div className="Home">
      <NaveBar />
      <Product />
      <Footer />
    </div>
  );
}

export default Home;